import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class CheckboxOrRadioGroup extends PureComponent{

	static propTypes = {
		errorMessage: PropTypes.string,
		name: PropTypes.string,
		values: PropTypes.arrayOf(PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			disabled: PropTypes.bool
		})),
		inputType: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
		selected: PropTypes.string,
		onChange: PropTypes.func,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func
	}

	static defaultProps = {
		type: 'radio',
	}

	static renderForForm({input : {value, ...otherInput}, meta: {initial, touched, error }, ...custom}){
		return (
			<CheckboxOrRadioGroup
				errorMessage={touched && error ? error : undefined}
				selected={value || initial}
				{...otherInput}
				{...custom}
			/>
		)
	}

	render(){
		const {inputType, name, selected, values, onChange, errorMessage} = this.props

		const errorMessageComponent = errorMessage ? <span className="help-block">{errorMessage}</span> : undefined

		return (
			<div className={classNames({'has-error': !!errorMessage})}>
				{
					values.map(({label, value, disabled}) => (
						<div className={classNames(inputType, {disabled: disabled})} key={`${name}-${label}`}>
							<label className="control-label">
								<input
									type={inputType}
									name={name}
									value={value}
									disabled={disabled}
									checked={selected === value}
									onChange={onChange}
									//onFocus={onFocus}
									//onBlur={onBlur} // This seems to cause redux form to set the value during blur... which isn't what we want
								/>
								{label}
							</label>
						</div>
					))
				}
				{errorMessageComponent}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./client/components/forms/CheckboxOrRadioGroup.js